import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CoasService {

  private url = environment.api + "api/erp/coas";
  
  constructor(
    private http: HttpClient,
  ) { }

  createCoa(data: any) {
    return this.http.post(this.url, data);
  }

  getCoas(){
    return this.http.get(this.url);
  }

  getCoasById(coasDocumentId: any){
    return this.http.get(this.url + `/${coasDocumentId}`);
  }

  deleteCoasById(coasDocumentId: any){
    return this.http.delete(this.url + `/${coasDocumentId}`);
  }
  
  getCoasDetailById(coasDocumentId: any){
    return this.http.get(this.url + `/details/${coasDocumentId}`);
  }


}
